import styled from 'styled-components'

export const StyledArticle = styled.div``
export const ButtonWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  ${({ singleMode }) => (singleMode ? 'justify-content: end;' : 'justify-content: space-between;')}
`
